import { render, staticRenderFns } from "./CustomSwitch.vue?vue&type=template&id=55d17d84&scoped=true"
import script from "./CustomSwitch.vue?vue&type=script&lang=js"
export * from "./CustomSwitch.vue?vue&type=script&lang=js"
import style0 from "./CustomSwitch.vue?vue&type=style&index=0&id=55d17d84&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d17d84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55d17d84')) {
      api.createRecord('55d17d84', component.options)
    } else {
      api.reload('55d17d84', component.options)
    }
    module.hot.accept("./CustomSwitch.vue?vue&type=template&id=55d17d84&scoped=true", function () {
      api.rerender('55d17d84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainContent/CustomSwitch.vue"
export default component.exports